import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface DeleteDedicationResponse extends MiddlewareAPIResponse
{
    
}

export class DeleteDedicationResponseDtoImpl extends MiddlewareDtoImpl implements DeleteDedicationResponse
{
   
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/mytunes/deletededication/deletededicationresponse.tsx